import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/system'

import ForestImage from 'src/assets/images/forest.image.png'
import Label from 'src/assets/images/label.image.png'

import { useStyles } from './styles'

const AuthHero = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  // Styling
  const classes = useStyles()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  return (
    <Grid
      sx={{
        display: isLaptop ? 'none' : 'block',
      }}
      item
      xs={6}
      height={'100vh'}
    >
      <img alt={ForestImage} src={ForestImage} height={'100%'} width={'100%'} loading="eager" />
      <img
        alt={Label}
        src={Label}
        style={{ position: 'absolute', top: '7%', left: '7%', transform: 'translateX(50%)' }}
        loading="eager"
      />
      <span className={classes.aboutUsDescr}>
        {t('auth-hero-title-1.v')} <span className={classes.aboutUsDescrAccent}>Trackgood</span>.{' '}
        {t('auth-hero-title-2.v')}{' '}
        <span className={classes.aboutUsDescrAccent}>{t('auth-hero-title-3.v')}</span>{' '}
        {t('auth-hero-title-4.v')}{' '}
        <span className={classes.aboutUsDescrAccent}>{t('auth-hero-title-5.v')}</span>.
      </span>
    </Grid>
  )
}

export { AuthHero }
